<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<footer class="footer">
  <mat-toolbar color="primary">
      <span class="footer-left" i18n>
        <a href="{{ee4eManualURL}}" target="_blank">EE4E Manual</a>
      </span>
      <span class="footer-center" i18n>
        <a href="{{causalImpactURL}}" target="_blank">Causal Impact</a>
      </span>
    <span class="footer-right" i18n>
      <div>About:</div>
      <mat-list>
        <mat-list-item class="footer-text-bullet">
          <span>Client version: </span>
          <span>{{ee4eClientVersion}} </span>
        </mat-list-item>
        <mat-list-item class="footer-text-bullet">
          <span>Server version: </span>
          <span>{{ee4eBackendVersion}} </span>
        </mat-list-item>
        <mat-list-item class="footer-text-bullet">
          <span>Core package version: </span>
          <span>{{ee4eCorePackageVersion}} </span>
        </mat-list-item>
      </mat-list>
    </span>
  </mat-toolbar>
</footer>